<template>
  <div class="black-list-container">
    <div class="list-header">
      <h3>黑名单管理</h3>
      <p class="description">添加用户到黑名单后，这些用户将无法购买此商品</p>
    </div>

    <div class="search-box">
      <el-input
        placeholder="请输入用户名或手机号搜索"
        v-model="searchQuery"
        class="search-input"
        clearable
        @clear="handleClear"
      >
        <el-button slot="append" icon="el-icon-search" @click="searchUsers"></el-button>
      </el-input>
      <el-button type="primary" @click="addUsersDialogVisible = true">添加用户</el-button>
    </div>

    <!-- 黑名单用户列表 -->
    <div class="list-content">
      <el-table
        v-loading="loading"
        :data="blackListUsers"
        border
        style="width: 100%"
      >
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="nickname" label="用户名称">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :size="40" :src="scope.row.avatarUrl" v-if="scope.row.avatarUrl"></el-avatar>
              <el-avatar :size="40" icon="el-icon-user" v-else></el-avatar>
              <span class="user-name">{{ scope.row.nickname }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="addTime" label="添加时间" width="180"></el-table-column>
        <el-table-column prop="reason" label="拉黑原因"></el-table-column>
        <el-table-column label="操作" width="60">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="danger"
              @click="removeFromBlackList(scope.row)"
            >移除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 添加用户弹窗 -->
    <el-dialog
      title="添加黑名单用户"
      :visible.sync="addUsersDialogVisible"
      width="60%">
      <div class="dialog-search-box">
        <el-input
          placeholder="请输入用户名或手机号搜索"
          v-model="dialogSearchQuery"
          class="search-input"
          clearable
        >
          <el-button slot="append" icon="el-icon-search" @click="searchDialogUsers"></el-button>
        </el-input>
      </div>

      <el-table
        v-loading="dialogLoading"
        :data="searchedUsers"
        border
        style="width: 100%"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="userId" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="nickname" label="用户名称">
          <template slot-scope="scope">
            <div class="user-info">
              <el-avatar :size="40" :src="scope.row.avatarUrl" v-if="scope.row.avatarUrl"></el-avatar>
              <el-avatar :size="40" icon="el-icon-user" v-else></el-avatar>
              <span class="user-name">{{ scope.row.nickname }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="mobile" label="手机号"></el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="180"></el-table-column>
      </el-table>

      <!-- 拉黑原因 -->
      <div class="reason-input">
        <el-form :model="blackListForm" label-width="80px">
          <el-form-item label="拉黑原因">
            <el-input
              type="textarea"
              :rows="3"
              placeholder="请输入拉黑原因（选填）"
              v-model="blackListForm.reason">
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 弹窗分页 -->
      <div class="pagination-container">
        <el-pagination
          @size-change="handleDialogSizeChange"
          @current-change="handleDialogCurrentChange"
          :current-page="dialogCurrentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="dialogPageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="dialogTotal">
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="addUsersDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addToBlackList">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PorductApi from '@/api/product.js';

export default {
  name: 'BlackList',
  props: {
    productId: {
      type: [Number, String],
      default: 0
    }
  },
  data() {
    return {
      loading: false,
      blackListUsers: [],
      searchQuery: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,

      // 添加用户弹窗
      addUsersDialogVisible: false,
      dialogLoading: false,
      dialogSearchQuery: '',
      searchedUsers: [],
      selectedUsers: [],
      dialogCurrentPage: 1,
      dialogPageSize: 10,
      dialogTotal: 0,

      // 拉黑表单
      blackListForm: {
        reason: ''
      }
    };
  },
  created() {
    this.getBlackListUsers();
  },
  methods: {
    // 获取黑名单用户
    getBlackListUsers() {
      this.loading = true;
      const params = {
        productId: this.productId,
        page: this.currentPage,
        pageSize: this.pageSize,
        searchQuery: this.searchQuery
      };

      // 这里应该调用实际的API
      PorductApi.getBlackListUsers(params)
        .then(res => {
          this.blackListUsers = res.data.list;
          this.total = res.data.total;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$message.error('获取黑名单用户失败');
          // 模拟数据，实际开发中删除
          this.mockBlackListData();
        });
    },

    // 搜索黑名单用户
    searchUsers() {
      this.currentPage = 1;
      this.getBlackListUsers();
    },

    // 清除搜索
    handleClear() {
      this.searchQuery = '';
      this.searchUsers();
    },

    // 分页大小变化
    handleSizeChange(val) {
      this.pageSize = val;
      this.getBlackListUsers();
    },

    // 页码变化
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getBlackListUsers();
    },

    // 搜索弹窗用户
    searchDialogUsers() {
      this.dialogLoading = true;
      const params = {
        page: this.dialogCurrentPage,
        pageSize: this.dialogPageSize,
        searchQuery: this.dialogSearchQuery
      };

      // 这里应该调用实际的API
      PorductApi.searchUsers(params)
        .then(res => {
          this.searchedUsers = res.data.list;
          this.dialogTotal = res.data.total;
          this.dialogLoading = false;
        })
        .catch(error => {
          this.dialogLoading = false;
          this.$message.error('搜索用户失败');
          // 模拟数据，实际开发中删除
          this.mockSearchedUsers();
        });
    },

    // 弹窗分页大小变化
    handleDialogSizeChange(val) {
      this.dialogPageSize = val;
      this.searchDialogUsers();
    },

    // 弹窗页码变化
    handleDialogCurrentChange(val) {
      this.dialogCurrentPage = val;
      this.searchDialogUsers();
    },

    // 表格选择变化
    handleSelectionChange(val) {
      this.selectedUsers = val;
    },

    // 添加到黑名单
    addToBlackList() {
      if (this.selectedUsers.length === 0) {
        this.$message.warning('请选择要添加的用户');
        return;
      }

      const userIds = this.selectedUsers.map(user => user.userId);
      const params = {
        productId: this.productId,
        userIds: userIds,
        reason: this.blackListForm.reason
      };

      // 这里应该调用实际的API
      PorductApi.addToBlackList(params)
        .then(res => {
          this.$message.success('添加成功');
          this.addUsersDialogVisible = false;
          this.blackListForm.reason = '';
          this.getBlackListUsers();
        })
        .catch(error => {
          this.$message.error('添加失败');
          // 模拟成功，实际开发中删除
          this.$message.success('添加成功');
          this.addUsersDialogVisible = false;
          this.blackListForm.reason = '';
          this.getBlackListUsers();
        });
    },

    // 从黑名单移除
    removeFromBlackList(user) {
      this.$confirm('确定将该用户从黑名单中移除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const params = {
          productId: this.productId,
          userId: user.userId
        };

        // 这里应该调用实际的API
        PorductApi.removeFromBlackList(params)
          .then(res => {
            this.$message.success('移除成功');
            this.getBlackListUsers();
          })
          .catch(error => {
            this.$message.error('移除失败');
            // 模拟成功，实际开发中删除
            this.$message.success('移除成功');
            this.getBlackListUsers();
          });
      }).catch(() => {});
    },

    // 模拟黑名单数据，实际开发中删除
    mockBlackListData() {
      this.blackListUsers = [
        {
          userId: 2001,
          nickname: '赵六',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13900139001',
          addTime: '2023-06-10 09:15:22',
          reason: '恶意下单不付款'
        },
        {
          userId: 2002,
          nickname: '钱七',
          avatarUrl: '',
          mobile: '13900139002',
          addTime: '2023-06-12 16:40:33',
          reason: '多次投诉商品质量'
        }
      ];
      this.total = 2;
      this.loading = false;
    },

    // 模拟搜索用户数据，实际开发中删除
    mockSearchedUsers() {
      this.searchedUsers = [
        {
          userId: 1001,
          nickname: '张三',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13800138001',
          createTime: '2023-01-10 08:30:45'
        },
        {
          userId: 1002,
          nickname: '李四',
          avatarUrl: '',
          mobile: '13800138002',
          createTime: '2023-01-15 09:22:33'
        },
        {
          userId: 1003,
          nickname: '王五',
          avatarUrl: 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png',
          mobile: '13800138003',
          createTime: '2023-02-05 16:40:12'
        }
      ];
      this.dialogTotal = 3;
      this.dialogLoading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.black-list-container {
  padding: 20px;

  .list-header {
    margin-bottom: 20px;

    h3 {
      font-size: 20px;
      margin: 0 0 10px 0;
      color: #303133;
      font-weight: 600;
      position: relative;
      padding-left: 12px;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 4px;
        height: 18px;
        background-color: #F56C6C;
        border-radius: 2px;
      }
    }

    .description {
      color: #909399;
      font-size: 14px;
      margin: 0;
      padding-left: 12px;
    }
  }

  .search-box {
    display: flex;
    margin-bottom: 20px;
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;

    .search-input {
      width: 300px;
      margin-right: 15px;

      /deep/ .el-input__inner {
        border-radius: 20px;
      }
    }

    .el-button {
      border-radius: 20px;
    }
  }

  .list-content {
    background-color: #fff;
    border-radius: 4px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    transition: all 0.3s ease;

    &:hover {
      box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.15);
    }
  }

  .user-info {
    display: flex;
    align-items: center;

    .user-name {
      margin-left: 10px;
    }
  }

  .pagination-container {
    margin-top: 20px;
    text-align: right;
  }

  .dialog-search-box {
    margin-bottom: 20px;

    .search-input {
      width: 300px;
    }
  }

  .reason-input {
    margin: 20px 0;
    background-color: #fef9f8;
    padding: 15px;
    border-radius: 4px;
    border-left: 3px solid #F56C6C;

    .el-form-item__label {
      font-weight: 500;
    }

    .el-textarea__inner {
      border-color: #f0d0d0;

      &:focus {
        border-color: #F56C6C;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/product/part/BlackList.vue